import { jsx as _jsx } from "react/jsx-runtime";
import { PaymentGroupName } from '@as-react/common-types';
import { PaymentGroupGeneric } from './PaymentGroupGeneric';
import { PaymentGroupBancontact } from './PaymentGroupBancontact';
import { PaymentGroupKlarna } from './PaymentGroupKlarna';
import { PaymentGroupCreditCard } from './PaymentGroupCreditCard';
export const PaymentGroup = props => {
    const { group } = props;
    const groupName = group.name.toUpperCase().indexOf(PaymentGroupName.KLARNA) !== -1 ? PaymentGroupName.KLARNA : group.name;
    switch (groupName) {
        case PaymentGroupName.BANCONTACT_SAFERPAY:
            return _jsx(PaymentGroupBancontact, Object.assign({}, props));
        case PaymentGroupName.KLARNA:
            return _jsx(PaymentGroupKlarna, Object.assign({}, props));
        case PaymentGroupName.CREDITCARD:
            return _jsx(PaymentGroupCreditCard, Object.assign({}, props));
        case PaymentGroupName.IDEAL:
        case PaymentGroupName.PAYPAL:
        case PaymentGroupName.APPLEPAY_SAFERPAY:
        case PaymentGroupName.GOOGLEPAY_SAFERPAY:
        case PaymentGroupName.ECOCHEQUE:
            return _jsx(PaymentGroupGeneric, Object.assign({}, props));
        default:
            return null;
    }
};
